// extracted by mini-css-extract-plugin
export default {"root":"LessonSlide-modules__root__zsfM5","content":"LessonSlide-modules__content__Of1V6"};